// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#98A1B4",
	"menuActiveText": "#1D3A71",
	"subMenuActiveText": "#1D3A71",
	"menuBg": "#fff",
	"menuHover": "#F0F2F4",
	"subMenuBg": "#fff",
	"subMenuHover": "#F0F2F4",
	"sideBarWidth": "264px",
	"menuContainerBg": "#fff"
};
module.exports = exports;
